import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'
import LocalizationService from '@/services/localization-service'
import CommonTableActions from '@/constants/common-table-actions'

const QuestionsTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/admin/help/section/questions`,
  rowsPath: 'questions',
  rowClickable: true,
  columns: [
    {
      label: 'help.question',
      field: 'locales',
      formatFn: (val: any) => LocalizationService.getTranslate(val, 'question', LocalizationService.getCurrentLocale()),
    },
    {
      label: 'help.attachment',
      field: 'video',
      formatFn: (val: any) => (val ? 'Yes' : 'No'),
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },
  actions: [
    ...CommonTableActions,
  ],
  filters: [
  ],
}

export default QuestionsTableConfig
